import React from 'react';
import { useDispatch } from 'react-redux';
import { loadFormDefinition } from '@redux/modules/formGeneration';

const ListingsDropdown = props => {
  const dispatch = useDispatch();

  // loads form definitions based on the data attribute of the <button> that was clicked
  const handleClicked = e => {
    const clickedItem = e?.currentTarget?.dataset?.id;
    if (clickedItem) {
      const [operationType, definitionType, listingType] = clickedItem.split('-');
      dispatch(loadFormDefinition(operationType, definitionType, listingType, null, 'listing'));
    }
  };

  return (
    <>
      <div className="dropdown-menu dropdown-menu-right" {...props}>
        <button className="dropdown-item" type="button" data-id="create-listings-res" onClick={handleClicked}>
          <i className="fas fa-home-lg mr-2" />
          Residential
        </button>
        <button className="dropdown-item " type="button" data-id="create-listings-mult" onClick={handleClicked}>
          <i className="fas fa-building mr-2" />
          Multi-family
        </button>
        <button className="dropdown-item" type="button" data-id="create-listings-rnt" onClick={handleClicked}>
          <i className="fas fa-store-alt mr-2" />
          Rental
        </button>
        <button className="dropdown-item " type="button" data-id="create-listings-mob" onClick={handleClicked}>
          <i className="fas fa-caravan mr-2" />
          Mobile
        </button>
        <button className="dropdown-item" type="button" data-id="create-listings-land" onClick={handleClicked}>
          <i className="fas fa-mountains mr-2" />
          Land
        </button>
        <button className="dropdown-item" type="button" data-id="create-listings-com" onClick={handleClicked}>
          <i className="fas fa-city mr-2" />
          Commercial
        </button>
        <button className="dropdown-item" type="button" data-id="create-listings-farm" onClick={handleClicked}>
          <i className="fas fa-farm mr-2" />
          Agribusiness
        </button>
      </div>
    </>
  );
};

export default ListingsDropdown;
